import { createContext, type ReactNode, useCallback, useContext, useState } from 'react';
import { createPortal } from 'react-dom';

import { Turnstile } from '@components/Turnstile/Turnstile';

// Pages under OrderLayout register the node under their action row; one widget is portaled there.
const TurnstileSlotContext = createContext<((node: HTMLElement | null) => void) | null>(null);

export function TurnstileSlotProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  const setSlotNode = useCallback((node: HTMLElement | null) => {
    setSlot(node);
  }, []);

  return (
    <TurnstileSlotContext.Provider value={setSlotNode}>
      {children}
      {slot ? createPortal(<Turnstile execution='execute' />, slot) : null}
    </TurnstileSlotContext.Provider>
  );
}

export function TurnstileAnchor() {
  const setSlotNode = useContext(TurnstileSlotContext);
  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      setSlotNode?.(node);
    },
    [setSlotNode],
  );

  if (!setSlotNode) return <Turnstile execution='execute' />;
  return <div ref={ref} data-testid='turnstile-anchor' />;
}
